<template>
  <div class="container my-5">
    <div class="row justify-content-center">
      <div class="col-md-12 col-lg-10">
        <h1 class="h4 text-center">
          {{ $t("terms_of_use.candidates.sj.title") }}
        </h1>
        <div class="my-5" v-if="termsOfUse" v-html="termsOfUse"></div>
      </div>
    </div>
  </div>
</template>

<script>
import companyMixin from "@state/company";
export default {
  mixins: [companyMixin],
  created() {
    // Only Sj context
    if (!this.company.config.sj) {
      this.$router.push({ name: "home" });
    }
  },
  computed: {
    termsOfUse() {
      return this.$t("terms_of_use.candidates.sj.content");
    },
  },
};
</script>